import React, {useState} from 'react';
import { useForm } from 'antd/lib/form/Form';
import { Button, Form, Input, Empty} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {usePedido} from '../../services/usePedidos';
//import {reducerPedidoTypes} from '../../../store/reducer-pedido';
import {faComment, faSave} from '@fortawesome/pro-duotone-svg-icons';
import { useDispatch } from 'react-redux';

const ButtonEditarObs = ({label, onClick}) => {
    return (<Button onClick={onClick}>{label}</Button>)
}

const EmptyPedido = ({abrirEdicaoObsHandle, label}) => {
    let emptyDescription= "Nenhuma "+ label + " para esse pedido!";
    return (<Empty description={emptyDescription} 
                    image={<FontAwesomeIcon size="5x" 
                    icon={faComment}></FontAwesomeIcon>}>
                   <ButtonEditarObs onClick={abrirEdicaoObsHandle} label={"Inserir " + label}/>
                </Empty>);
}
 
const FormObsPedido2 = ({/* dispatch, */ pedido, campo, label, setFormVisible}) => {
    const [form] = useForm()
    const {atualizaPedido} = usePedido();
    let [loading, setLoading] = useState(false);
    /* const reducerPedido = useSelector((state) => x);
    const pedido = reducerPedido.pedido;*/
    const dispatch = useDispatch(); 
 
    const salvaCampo = async () => {
        setLoading(true);
        const valorCampo = form.getFieldValue(campo);
        pedido[campo] = valorCampo;
        const novoPedido = await atualizaPedido(pedido);
        dispatch({type: 'setPedido' , payload: novoPedido});
        setLoading(false);
        setFormVisible(false);
    }

    return (<Form form={form} layout="vertical" key={pedido}>
        <Form.Item name={campo} label={label} initialValue={pedido[campo]}>
            <Input.TextArea rows={4}  />
        </Form.Item>
        <Form.Item style={{textAlign: "right"}}>
            <Button type="default" onClick={salvaCampo} loading={loading}>
               <FontAwesomeIcon icon={faSave}></FontAwesomeIcon> 
               Salvar {label}
            </Button>
        </Form.Item>
    </Form>)
}

const FormPedidoDescricoes = ({ pedido,  abrirEdicaoObsHandle, formVisible, campo, label, setFormVisible}) => {
    
    if(!formVisible){
        if(!pedido[campo]){
            return <EmptyPedido abrirEdicaoObsHandle={abrirEdicaoObsHandle} label={label} />
        } 
        return (<>
            <div style={{
                    whiteSpace: 'pre-wrap',
                    textAlign: 'left'
            }}>{pedido[campo]}</div>
            <ButtonEditarObs onClick={abrirEdicaoObsHandle} label={"Editar " + label}/>
        </>)
    } 

    return <FormObsPedido2 campo={campo} label={label} setFormVisible={setFormVisible}  pedido={pedido}   />

}

export {FormPedidoDescricoes}